<template>
  <div class="game">
    <GameBoard v-if="gameStarted" />
    <GameSettings v-else-if="game" />
    <div v-else>loading...</div>
  </div>
</template>

<script>
import GameSettings from '@/components/GameSettings.vue'
import GameBoard from '@/components/GameBoard.vue'

export default {
  name: 'GamePage',
  components: { GameSettings, GameBoard },

  computed: {
    game () { return this.$store.state.game; },
    player () { return this.$store.state.player; },
    gameStarted () { return this.game && this.game.has_started; }
  },

  watch: {
    $route () { this.joinGameFromURL(); }
  },

  methods: {
    joinGameFromURL () {
      const gameAuth = this.$route.params.gameAuth;
      if (!gameAuth) { return false; }

      let playerAuth = this.player ? this.player.auth_token : '';
      if (!playerAuth) {
        let playerInfo = this.$cookies.isKey('cgp') ? this.$cookies.get('cgp').split('|') : [];
        playerAuth = playerInfo.length > 0 ? playerInfo[0] : '';
        if (!playerAuth) { return false; }
      }

      this.$socket.emit('game_join', { game: { auth: gameAuth }, player: { auth: playerAuth } });
      return true;
    }
  },

  created () {
    if (!this.joinGameFromURL()) {
      if (this.$route.params.gameAuth) { this.$cookies.set('cgg', this.$route.params.gameAuth); }
      this.$router.push('/');
    }
  }
}
</script>
